import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReferralsCodeNavigateComponent } from 'src/app/public-website/public/components/referrals-code-navigate/referrals-code-navigate.component';
const publicRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
    pathMatch: "full"
  },
  {
    path: 'contact',
    loadChildren: () => import('./components/contact/contact.module').then(m => m.ContactModule)
  },
  {
    path: 'about-us',
    loadChildren: () => import('./components/about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: 'services/:service',
    loadChildren: () => import('./components/services/services.module').then(m => m.ServicesModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./components/signup/signup.module').then(m => m.SignupModule)
  },
  {
    path: 'new/business/onboarding',
    loadChildren: () => import('./components/signup/signup.module').then(m => m.SignupModule)
  },
  {
    path: 'products/browse',
    loadChildren: () => import('./components/browse/browse.module').then(m => m.BrowseModule)
  },
  {
    path: 'events',
    loadChildren: () => import('./components/events-page/events-page.module').then(m => m.BrowseModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./components/faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'terms',
    loadChildren: () => import('./components/terms/terms.module').then(m => m.TermsModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./components/privacy/privacy.module').then(m => m.PrivacyModule)
  },
  {
    path: '404',
    loadChildren: () => import('./components/page404/page404.module').then(m => m.Page404Module)
  },
  {
    path: "search/:searchWord",
    loadChildren: () => import('./components/products-search/products-search.module').then(m => m.ProductsSearchModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./components/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'password/reset/:token',
    loadChildren: () => import('./components/reset-password/reset-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'signup/member/:token',
    loadChildren: () => import('./components/sign-up-team-member/sign-up-team-member.module').then(m => m.SignUpTeamMemberModule)
  },
  { path: "email/verify/:token",
    loadChildren: () => import('./components/mailVerification/activateMail.module').then(m => m.ActivateMailModule)
  },
  { path: 'seller/referral/:code', component: ReferralsCodeNavigateComponent },
  { path: 'pre-signup',  loadChildren: () => import('./components/leads-submission/leads-submission.module').then(m => m.LeadsSubmissionModule) },
  {
    path: 'changePassword',
    loadChildren: () => import('./components/change-lastpassword/change-lastpassword.module').then(m => m.ChangePasswordModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(publicRoutes)],
  exports: [RouterModule],
  providers: [],
})
export class PublicRoutingModule { }
